import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export interface IDetalhesSolicitacaoFinanceira {
  codigoConta: string;
  documento: number;
  derivadoVenda: boolean;
  bancoAgencia: string;
  cidadeUf: string;
  emissao: string;
  vencimento: string;
  pagamento: string;
  codHistorico: number;
  historico: string;
  complemento: string;
  tipo: string;
  valor: number;
  digitador: string;
  dataHoraDigitacao: string;
  conferente1: string;
  dataHoraConferencia1: string;
  conferente2: string;
  dataHoraConferencia2: string;
  mesRef: string;
  atualizacao: string;
  codUsuario: number;
  transferiu: string;
  codigoContaOrigem: string;
  documentoOrigem: string;
  origemDocumento: string;
  infoOrigem: string;
  cheque: string;
  codLoja: number;
  contabil: string;
  codSubCc: number;
  codFormaPgto: number;
  idcaixa: string;
  depNaoIndent: string;
  dataContabil: string;
  codOperadorCx: number;
  ecfcupom: number;
  coo: number;
  numeroLote: string;
  docArqBank: null;
  histContabil: string;
  statusEnvioServidor: null;
  codLojaContabil: number;
  ignorarContabilidade: string;
  flagenviado: null;
  dataConciliado: null;
  codUsuarioConciliado: null;
  docbancarioOfx: string;
  autorizado: string;
  tipoEnvio: string;
  valorTotal: number;
  docFina: string;
  
  [chave: string]: string | number | null | boolean;
}

export const ObterDetalhesSolicitacaoFinanceira = async (
  documento: number,
  codigoConta: string
): Promise<IDetalhesSolicitacaoFinanceira> => {
  const { token } = obterParametrosDaURL();

  try {

    const { data } = await api.get<IDetalhesSolicitacaoFinanceira>(
      `/obter-detalhes-da-solicitacao-financeira`,
      { params: { documento, codigoConta }, headers: { token } }
    );

    return data;
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não foi possível obter os detalhes da solicitação financeira"
    );
  }
};